<div class="avail animate-fade-in">

  <!-- Header -->
  <header class="avail__header stagger-1">
    <div>
      <h1>Disponibilidad semanal</h1>
      <p>Configurá los días y horarios en los que aceptás reservas.</p>
    </div>
  </header>

  <!-- Schedule table -->
  <div class="avail__grid stagger-2">
    <div
      class="day-row"
      *ngFor="let row of rows"
      [class.day-row--disabled]="!row.enabled"
    >
      <!-- Toggle + day name -->
      <div class="day-row__label">
        <button
          class="toggle"
          [class.toggle--on]="row.enabled"
          (click)="toggle(row)"
          [attr.aria-label]="'Activar ' + row.name"
        >
          <span class="toggle__track">
            <span class="toggle__thumb"></span>
          </span>
        </button>
        <span class="day-name">{{ row.name }}</span>
      </div>

      <!-- Time range -->
      <div class="day-row__times" *ngIf="row.enabled">
        <select class="time-select" [(ngModel)]="row.from">
          <option *ngFor="let t of timeOptions" [value]="t">{{ t }}</option>
        </select>
        <span class="time-sep">a</span>
        <select class="time-select" [(ngModel)]="row.to">
          <option *ngFor="let t of timeOptions" [value]="t">{{ t }}</option>
        </select>
      </div>

      <!-- Closed label -->
      <div class="day-row__closed" *ngIf="!row.enabled">
        <span class="material-symbols-outlined">block</span>
        No disponible
      </div>
    </div>
  </div>

  <!-- Save -->
  <div class="avail__footer stagger-3">
    <div class="save-feedback" *ngIf="saved">
      <span class="material-symbols-outlined">check_circle</span>
      Disponibilidad guardada
    </div>
    <button class="btn-primary" (click)="saveAll()">
      <span class="material-symbols-outlined">save</span>
      Guardar cambios
    </button>
  </div>

</div>
